import React from "react";
import Image from "components/image";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import trustedIcon from "./images/icon-trusted-1m-customers.png";
import warrantyIcon from "./images/icon-lifetime-warranty.png";
import shippingIcon from "./images/icon-free-shipping.png";

const DEFAULT_ITEMS = [
    {
        title: "TRUSTED BY",
        subtitle: "1M+ CUSTOMERS",
        icon: trustedIcon,
    },
    {
        title: "LIFETIME",
        subtitle: "WARRANTY",
        icon: warrantyIcon,
    },
    {
        title: "FREE SHIPPING",
        subtitle: "30-DAY RETURNS",
        icon: shippingIcon,
    },
];

const DEFAULT_ICONS = DEFAULT_ITEMS.map((item) => item.icon);

const hasSanityImage = (icon) => Boolean(icon?.asset || icon?._ref);

const getItemIcon = (item, index) => {
    if (hasSanityImage(item?.icon)) {
        return item.icon;
    }

    if (typeof item?.icon === "string") {
        return item.icon;
    }

    return DEFAULT_ICONS[index] || null;
};

const getAriaLabel = (bannerItems) => bannerItems
    .map((item) => [item?.title, item?.subtitle].filter(Boolean).join(" "))
    .filter(Boolean)
    .join(", ");

const TopBanner = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const items = data?.items?.length ? data.items : DEFAULT_ITEMS;

    if (!items.length) {
        return null;
    }

    return (
        <div className={`top-banner ${classes.join(" ")}`}>
            <ul className="top-banner__inner" aria-label={getAriaLabel(items)}>
                {items.map((item, index) => {
                    const icon = getItemIcon(item, index);
                    const iconAlt = item?.icon?.alt || "";

                    return (
                        <li key={item?._key || `${item?.title}-${index}`} className="top-banner__item">
                            {icon && (
                                <div className="top-banner__icon">
                                    <Image
                                        image={icon}
                                        alt={iconAlt}
                                        width={96}
                                        className="top-banner__icon-image"
                                        aria-hidden={!iconAlt}
                                    />
                                </div>
                            )}
                            <div className="top-banner__text">
                                {item?.title && (
                                    <span className="top-banner__title">{item.title}</span>
                                )}
                                {item?.subtitle && (
                                    <strong className="top-banner__subtitle">{item.subtitle}</strong>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default TopBanner;
